import type { FunctionComponent } from 'react';

import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { createStyleHelper, createClassName } from '../../../shared/utils/class-names';

import styles from './more-info.module.scss';

const style = createStyleHelper(styles, 'more-info');

export interface IMoreInfoProps {
    className?: string;
    activityMetadata?: Record<string, unknown>;
    activity: string;
}

export const MoreInfo: FunctionComponent<IMoreInfoProps> = ({
    className,
    activity,
    activityMetadata,
}) => {
    return (
        <div className={createClassName([className, style()])}>
            {activityMetadata?.details ? (
                <>
                    <FormattedMessage
                        id={`activity-table.activity.${activity}.details`}
                        defaultMessage="N/A"
                        values={activityMetadata.details as Record<string, string>}
                    />
                </>
            ) : (
                <FormattedMessage id="account.transactions.no-data" defaultMessage="N/A" />
            )}
        </div>
    );
};
